import closeMenuIcon from "assets/images/close-menu-icon.svg";
import hamburgerIcon from "assets/images/hamburger-icon-white.svg";
import classNames from "classnames";
import {useState} from "react";
import {Link, useLocation, useSearchParams} from "react-router-dom";
import {common as stringsCommon, header as strings} from "strings";

import DrawerMenu from "components/DrawerMenu";
import LogoIcon from "components/LogoIcon";

import {signOut, useAuthenticatedUser} from "lib/auth";
import {saveLocalStorage, KEYS} from "lib/storage";
import {useCurrentPharmacy} from "lib/useCurrentPharmacy";

import styles from "./Header.module.css";

type HeaderProps = {
  className?: string;
  pharmacyName: string;
  pharmacyLogoPath: string;
};

export default function Header(props: HeaderProps) {
  const [navIsActive, setNavIsActive] = useState(false);
  const [authenticatedUser] = useAuthenticatedUser();
  const location = useLocation();
  const [pharmacy] = useCurrentPharmacy();
  const [searchParams] = useSearchParams();
  const isDisabled =
    pharmacy?.rx365Enabled === false || location.pathname === "/redirect";

  return (
    <header
      className={classNames(
        styles.header,
        props.className,
        navIsActive && styles.stickyHeader,
      )}
    >
      <div className={styles.menuToggleContainer}>
        <div className={styles.pharmacyInfoContainer}>
          <Link className={styles.clickableArea} to={"/"}>
            <LogoIcon
              pharmacyName={props.pharmacyName}
              pharmacyLogoPath={props.pharmacyLogoPath}
            />
            <div className={classNames(styles.text, styles.pharmacyName)}>
              {props.pharmacyName}
            </div>
          </Link>
        </div>
        {isDisabled ? null : (
          <button
            className={styles.menuToggle}
            onClick={() => setNavIsActive(!navIsActive)}
          >
            <img
              src={navIsActive ? closeMenuIcon : hamburgerIcon}
              alt=""
              className={styles.menuIcon}
            />
            <div className={classNames(styles.text, styles.menuLabel)}>
              {navIsActive ? stringsCommon.close : strings.menu}
            </div>
          </button>
        )}
      </div>
      <DrawerMenu
        isOpen={navIsActive}
        setIsOpen={setNavIsActive}
        patientName={authenticatedUser?.data.name}
      />
      <nav className={styles.nav}>
        <div className={styles.pharmacyInfoContainer}>
          <Link className={styles.clickableArea} to={"/"}>
            <LogoIcon
              pharmacyName={props.pharmacyName}
              pharmacyLogoPath={props.pharmacyLogoPath}
            />
            <div className={classNames(styles.text, styles.pharmacyName)}>
              {props.pharmacyName}
            </div>
          </Link>
        </div>
        {isDisabled ? null : (
          <div className={styles.signInContainer}>
            {location.pathname === "/login" ? (
              <Link
                className={classNames(styles.text, styles.registerButton)}
                to={`/register?${searchParams.toString()}`}
              >
                {stringsCommon.register}
              </Link>
            ) : (
              <Link
                className={styles.text}
                to={
                  authenticatedUser ? "/" : `/login?${searchParams.toString()}`
                }
                onClick={() => {
                  if (authenticatedUser)
                    signOut().then(() => {
                      saveLocalStorage(KEYS.email, undefined);
                    });
                }}
              >
                {authenticatedUser
                  ? stringsCommon.signOut
                  : stringsCommon.login}
              </Link>
            )}
          </div>
        )}
      </nav>
    </header>
  );
}
